import actions from "@/store/apiGuide/actions";
import state from "@/store/apiGuide/states";
import mutations from "@/store/apiGuide/mutations";

const ApiGuideModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default ApiGuideModule;